/* ==========================================================
   DOCUMENT READY
   ========================================================== */
$(document).ready(function () {

    /* ======================================================
       WOW.js (Scroll Animations)
       ====================================================== */
    new WOW().init();


    /* ======================================================
       Sticky Header
       ====================================================== */
    window.addEventListener("scroll", function () {
        if (window.scrollY > 200) {
            document.body.classList.add("sticky-header");
        } else {
            document.body.classList.remove("sticky-header");
        }
    });




    /* ======================================================
       Mobile Menu Toggle
       ====================================================== */
    $(".menu-toggle-btn, .nav-close-btn, .nav-logo-wrap .close-icon, .nav-overlay").on("click", function () {
         
        $("body").removeClass("nav-open overflow-hidden");
    });

    $(".menu-toggle-btn").on("click", function (e) {
        e.stopPropagation();
        $("body").addClass("nav-open overflow-hidden");
    });



    /* ======================================================
       Submenu Handling (Dynamic Arrow + Toggle)
       ====================================================== */
    // Add arrow icon + class to li containing <ul>
    $(".main-nav li:has(ul)")
        .append('<i class="icon vector-arrow"></i>')
        .addClass("has-submenu");

    // Mobile submenu toggle
    $(document).on("click", ".main-nav li.has-submenu", function (e) {
        if ($(window).width() <= 1200 && !$(e.target).is("a")) {
            $(this).toggleClass("show");
            $(this).children("ul").slideToggle("slow");
        }
    });



    /* ======================================================
       Testimonial Slider
       ====================================================== */
    $(".testimonial-slider").slick({
        loop: false,
        dots: false,
        arrows: true,
        speed: 700,
        // adaptiveHeight: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        spaceBetween: 25,
        // autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    adaptiveHeight: true,
                },
            }
        ],
    });

    $('.review-video__button').on('click', function() {
        var $wrapper = $(this).closest('.review-video');
        var video = $wrapper.find('video')[0];

        if (video.paused) {
        video.play();
        $wrapper.addClass('is-playing');
        } else {
        video.pause();
        $wrapper.removeClass('is-playing');
        }
    });

    $('.review-video video').on('ended', function() {
        $(this).closest('.review-video').removeClass('is-playing');
    });

    var swiper = new Swiper(".free-guideline-slider", {
        slidesPerView: 3,
        spaceBetween: 24,
        loop: false,
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.3,
                spaceBetween: 15,
            },
            500: {
                slidesPerView: 1.8,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 2.4,
            },
            992: {
                slidesPerView: 3,
            },
        },
    });
    /* ======================================================
       Back to Top Button
       ====================================================== */
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 300) {
            $(".back-to-top-btn").addClass("show");
        } else {
            $(".back-to-top-btn").removeClass("show");
        }
    });

    $(".back-to-top-btn").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });



    /* ======================================================
       Mini Search Bar Toggle (Header Drawer)
       ====================================================== */
    $(".search-toggle-btn").on("click", function (e) {
        e.preventDefault();
        var $header = $("header");
        var isOpening = !$header.hasClass("search-open");
        $header.toggleClass("search-open");
        if (isOpening) {
            setTimeout(function () { $(".mini-search-input").focus(); }, 350);
        }
    });

    // Close button click
    $(document).on("click", ".mini-search-close", function () {
        $("header").removeClass("search-open");
    });

    // Close when clicking outside the header
    $(document).on("click", function (e) {
        if (!$(e.target).closest("header").length) {
            $("header").removeClass("search-open");
        }
    });

    // Close on ESC key
    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            $("header").removeClass("search-open");
        }
    });


    /* ======================================================
       Slider (Slick Slider)
       ====================================================== */
    $(".slider-for").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".slider-nav",
    });

    $(".slider-nav").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                },
            },
        ],
    });

    
  /* ======================================================
     Product Tabs Switcher
     ====================================================== */
  $('.tab-btn').on('click', function () {
    const tabId = $(this).data('tab');

    $('.tab-btn').removeClass('active');
    $(this).addClass('active');

    $('.tab-pane').removeClass('active');
    $(`#${tabId}`).addClass('active');
  });

    /* ======================================================
         FAQ Accordion Toggle
         ====================================================== */
    $('.faq-question').on('click', function () {
        const faqItem = $(this).closest('.faq-item');
        const faqAnswer = faqItem.find('.faq-answer');
    
        // Close other items
        $('.faq-item').not(faqItem).removeClass('active').find('.faq-answer').slideUp();
    
        // Toggle current item
        faqItem.toggleClass('active');
        faqAnswer.slideToggle();
    });
    
    /* ======================================================
      Sticky Gallery
      ====================================================== */
    if ($('.left-slide').length) {
        $('.left-slide').theiaStickySidebar({
            containerSelector: '.shop-detail-wrap',
            additionalMarginTop: 100,
            additionalMarginBottom: 30,
            minWidth: 767
        });
    }

    $('.dr-img-box').hover(
    function () {
        clearInterval($(this).data('badgeInterval'));
    },
    function () {

        const $box = $(this);
        const $badges = $box.find('.pdf-badge');

        let current = $badges.index($badges.filter('.active'));

        const interval = setInterval(function () {

            $badges.eq(current).removeClass('active');

            current = (current + 1) % $badges.length;

            $badges.eq(current).addClass('active');

        }, 2500);

        $box.data('badgeInterval', interval);
    }
);

});    

// document.addEventListener('DOMContentLoaded', () => {
//   const popup = document.getElementById('popmagicModal');

//   if (popup) {
//     popup.classList.remove('visible');
//     popup.style.display = 'none';
//   }
// });

// document.querySelector('.story-sec .popup-btn').addEventListener('click', () => {
//   const popup = document.getElementById('popmagicModal');

//   if (popup) {
//     popup.style.display = 'flex';
//     popup.classList.add('visible');
//   }

// });

document.addEventListener('DOMContentLoaded', function() {
  const button = document.getElementById('open-klaviyo-form');

  if (button) {
    button.addEventListener('click', function() {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'XSmqzG']);
    });
  }
});